import React from 'react';
import { Home, Wrench, Building2, ArrowRight } from 'lucide-react';
import { Card, CardContent } from './Card';
export function Services() {
  const mainServices = [{
    icon: <Home className="w-10 h-10 text-tx-red" data-id="element-233" />,
    title: 'Roof Replacement',
    description: 'Full tear-offs and replacements using premium materials from Owens Corning and Atlas. Backed by our lifetime labor warranty.'
  }, {
    icon: <Wrench className="w-10 h-10 text-tx-red" data-id="element-234" />,
    title: 'Roof Repair',
    description: 'Fast, reliable repairs for leaks, missing shingles, and storm damage. Repairs starting as low as $300 depending on scope.'
  }, {
    icon: <Building2 className="w-10 h-10 text-tx-red" data-id="element-235" />,
    title: 'Commercial Roofing',
    description: 'TPO, modified bitumen, and metal roofing solutions for DFW businesses, churches, and multi-family properties.'
  }];
  const secondaryServices = ['Gutters', 'Fences', 'Windows', 'Siding', 'Outdoor Living', 'Remodels', 'Pools', 'Patios'];
  return <section id="services" className="py-20 bg-white" data-id="element-236">
      <div className="container mx-auto px-4" data-id="element-237">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-238">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-extrabold text-tx-deep mb-4 tracking-tight" data-id="element-239">
            Roofing Services for Dallas Fort Worth Homeowners
          </h2>
          <div className="w-20 h-1.5 bg-tx-red mx-auto rounded-full" data-id="element-240"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-241">
          {mainServices.map((service, index) => <Card key={index} className="border-gray-100 shadow-md hover:shadow-xl transition-shadow duration-300 rounded-xl overflow-hidden group" data-id="element-242">
              <CardContent className="p-8" data-id="element-243">
                <div className="bg-tx-light w-20 h-20 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-244">
                  {service.icon}
                </div>
                <h3 className="text-2xl font-bold text-tx-deep mb-4" data-id="element-245">
                  {service.title}
                </h3>
                <p className="text-tx-body leading-relaxed mb-6" data-id="element-246">
                  {service.description}
                </p>
                <a href="#contact" className="inline-flex items-center text-tx-navy font-bold hover:text-tx-red transition-colors" data-id="element-247">
                  Learn More <ArrowRight className="w-4 h-4 ml-2" data-id="element-248" />
                </a>
              </CardContent>
            </Card>)}
        </div>

        <div className="text-center" data-id="element-249">
          <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-6" data-id="element-250">
            More Than Just Roofing
          </p>
          <div className="flex flex-wrap justify-center gap-3" data-id="element-251">
            {secondaryServices.map((service, index) => <span key={index} className="px-6 py-3 bg-tx-light text-tx-deep font-semibold rounded-full border border-gray-200 hover:border-tx-navy hover:bg-tx-navy hover:text-white transition-colors cursor-default" data-id="element-252">
                {service}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}